export default __webpack_public_path__ + "static/media/kleinbus_hinten.ce5dd0d0.jpg";